<template>
  <transition name="fade">
    <div class="scroll-indicator-wrapper" @click.prevent="scrollDown">
      <div v-if="show" class="scroll-indicator bounce icon icon--arrow-down">
        <span>Scroll for content</span>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'ScrollIndicator',
  props: {
    sectionIndex: {
      type: String,
      default: '1',
    },
    delay: {
      type: String,
      default: '2000',
    },
  },
  data() {
    return {
      show: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.show = true
    }, parseInt(this.delay, 10))
  },
  methods: {
    scrollDown() {
      const sections = document
        .getElementById('sectionsContainer')
        .getElementsByTagName('section')

      if (sections && sections.length > 1) {
        // scroll to a section inside the sectionsContainer
        // by using the index postion of the 'sectionIndex' propperty
        const header = document.getElementsByClassName('site-header')
        const scrollOptions = {
          easing: 'ease-in-out',
          cancelable: true,
          offset: header && header.length ? -header[0].clientHeight : -80,
        }
        this.$scrollTo(sections[parseInt(this.sectionIndex, 10)], scrollOptions)
      }
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/scss/settings';

.fade-enter-active,
.fade-leave-active {
  opacity: 1;
  transition: opacity 2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

.scroll-indicator-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
}

.scroll-indicator {
  bottom: 20px;
  cursor: pointer;
  left: calc(50% - 20px);
  position: absolute;
  transform: translateX(-50%);
  z-index: 100;

  &.bounce {
    animation-duration: 0.8s;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
    animation-name: bounce;
    animation-timing-function: linear;
  }

  &.icon {
    &::before {
      @include font-size(40);

      color: $white;
      margin-right: 0;
    }
  }

  span {
    @include text-hide;
  }
}
</style>
